type SendListener = (replyEntryId: string) => void;

let listener: SendListener | null = null;
let pending: string | null = null;

export const chatScrollBus = {
  attach(next: SendListener): () => void {
    listener = next;
    return () => {
      if (listener === next) listener = null;
    };
  },

  send(replyEntryId: string): void {
    if (listener) listener(replyEntryId);
    else pending = replyEntryId;
  },

  takePending(): string | null {
    const replyEntryId = pending;
    pending = null;
    return replyEntryId;
  },
};
